import { Consent } from "./consent.model";
import { Representative } from "./representative.model";

export class State {
  consent: Consent;
  relationships: Array<string>;
  guardianRelationships: Array<string>;
  insurances: Array<string>;
  potentialRepresentatives: Array<Representative>;
  schoolName: string;
  isStaff: boolean;
  schoolSystem: SchoolSystem;
}

export enum SchoolSystem {
  None,
  Jcps,
  Madison
}
